import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Accordion, AccordionSummary, AccordionDetails, Button, MenuItem, Select, FormControl, InputLabel, IconButton, Checkbox, TextField } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from "@mui/icons-material/Close";
import "./Subscriptions.css";
import { TableContext } from '../context';
import NotificationCenter from "./NotificationCenter";
import NotificationSettings from "./NotificationSettings";

const Subscriptions = () => {
  // const { graphData, setGraphData, tokenFetched, setTokenFetched, getToken, getTableData, fetchUserDetails, loading, setLoading } = useContext(TableContext);
  const { activeTab, setActiveTab, getSubscriptions, getNotifications, tokenFetched } = useContext(TableContext);
  const location = useLocation();

  useEffect(() => {
    if (tokenFetched){
      Promise.all([getSubscriptions(), getNotifications()]);
    }
  }, [tokenFetched]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab");
    if (tab) {
      setActiveTab(tab);
    }
  }, [location.search, setActiveTab]);

  const handleClickTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="subscription-container">
      {/* Tab header */}
      <div className="tabs">
        <button className={`tab ${activeTab === "NotificationCenter" ? "active" : ""}`} onClick={() => handleClickTab("NotificationCenter")}>Notification Center</button>
        <button className={`tab ${activeTab === "NotificationSettings" ? "active" : ""}`} onClick={() => handleClickTab("NotificationSettings")}>Notification Settings</button>
      </div>

      {activeTab === "NotificationCenter" ? <NotificationCenter /> : <NotificationSettings />}
    </div>
  );
};

export default Subscriptions;